import { HttpError } from './http-client'

export function readOtpSendLimitSeconds(err: unknown): number | null {
  if (!(err instanceof HttpError) || err.status !== 429) return null
  const body = err.body as { code?: unknown; data?: { retryAfterSeconds?: unknown } } | undefined
  if (body?.code !== 'otp_send_limit') return null
  const seconds = body.data?.retryAfterSeconds
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds < 1) return null
  return Math.ceil(seconds)
}
